const trimTrailingSlash = (value = '') => String(value || '').trim().replace(/\/$/, '')

const getConfiguredUrl = (value, fallback) => trimTrailingSlash(value) || fallback

export const productIntegrations = Object.freeze({
  agentPingWalletUrl: getConfiguredUrl(
    process.env.REACT_APP_AGENTPING_WALLET_URL,
    'https://www.agentping.ai/wallet'
  ),
  agentWolfProfileUrl: getConfiguredUrl(
    process.env.REACT_APP_AGENT_WOLF_PROFILE_URL,
    'https://www.buzzvibe.com/ai/agentwolf'
  ),
  matrixConsoleUrl: getConfiguredUrl(
    process.env.REACT_APP_MATRIX_CONSOLE_URL,
    'https://theme.merlinintelligence.ai/dashboard'
  ),
})